/**
 * FileRandomRes 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'
import type { FileData } from './file_data'

/**
 * FileRandomRes
 */
export interface FileRandomRes {
  /** 文件列表 */
  list?: FileData[]
}

/**
 * FileRandomRes Schema
 */
export const FileRandomResSchema: SchemaDefinition = {
  properties: {
    list: {
      description: '文件列表',
      format: '[]*model.FileData',
      items: { $ref: 'FileData', description: '' },
      type: 'array',
      label: '文件列表',
    },
  },
  type: 'object',
}
